import { useId } from 'react';

export interface SaudiRiyalSymbolProps {
  className?: string;
}

/** Saudi Riyal symbol SVG – fill uses currentColor to match surrounding text */
export function SaudiRiyalSymbol({ className }: SaudiRiyalSymbolProps) {
  const id = useId();
  const clipId = `sariyal-clip-${id.replace(/:/g, '')}`;
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <g clipPath={`url(#${clipId})`}>
        <path d="M13.3644 21.2613C12.9812 22.1109 12.7279 23.033 12.6309 24L20.74 22.2762C21.1232 21.4267 21.3763 20.5044 21.4735 19.5375L13.3644 21.2613Z" fill="currentColor" />
        <path d="M20.7399 17.1119C21.1231 16.2624 21.3764 15.3401 21.4735 14.3732L15.1567 15.7166V13.134L20.7397 11.9476C21.1229 11.0981 21.3762 10.1758 21.4733 9.20886L15.1565 10.5512V1.26324C14.1886 1.8067 13.329 2.53011 12.6302 3.38341V11.0883L10.1039 11.6253V0C9.13603 0.543271 8.27642 1.26687 7.57766 2.12017V12.1621L1.92508 13.3632C1.54189 14.2127 1.2884 15.135 1.19117 16.1019L7.57766 14.7447V17.9971L0.733286 19.4515C0.350093 20.301 0.0967958 21.2233 -0.000244141 22.1902L7.1639 20.6678C7.7471 20.5465 8.24834 20.2017 8.57423 19.7272L9.88809 17.7793V17.7789C10.0245 17.5774 10.1039 17.3344 10.1039 17.0727V14.2078L12.6302 13.6708V18.8361L20.7397 17.1115L20.7399 17.1119Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="21.4737" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
